import { useEffect } from "react";
import { createPortal } from "react-dom";
import "./modal.css";

export default function Modal({ open, onClose, children, width = 920 }) {
    useEffect(() => {
        if (!open) return;
        const onEsc = (e) => e.key === "Escape" && onClose?.();
        document.addEventListener("keydown", onEsc);
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onEsc);
            document.body.style.overflow = "";
        };
    }, [open, onClose]);

    if (!open) return null;

    return createPortal(
        <div className="modal-overlay" onMouseDown={onClose}>
            <div
                className="modal-sheet"
                style={{ maxWidth: width }}
                onMouseDown={(e) => e.stopPropagation()}
            >
                <button className="modal-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
                <div className="modal-body">{children}</div>
            </div>
        </div>,
        document.body
    );
}
